import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "DashboardAesthetics"
});
const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  opacity: "0.6",
  d: "M19.1598 6.66875C19.2517 6.67188 19.2717 6.77063 19.2286 6.9425C19.2211 6.94168 19.2136 6.94126 19.2061 6.94125C19.0886 6.94125 18.9917 7.09625 18.8979 7.2375L18.8542 7.30375L18.8336 7.335L18.7898 7.39875C18.5961 7.68 18.3086 8.03 17.2242 9.135C15.7317 10.6575 12.3267 12.03 10.0129 12.0069C7.70045 12.03 4.30232 10.6569 2.80982 9.135C1.5142 7.81375 1.35607 7.57125 1.13545 7.2375C1.0267 7.07313 0.920448 6.90438 0.771698 6.95625C0.725448 6.78563 0.739823 6.68313 0.821698 6.66938C1.1617 6.86625 1.9242 7.21125 2.95607 7.57188C3.11357 8.7625 4.17607 9.88313 6.11857 10.5719C7.24107 10.9781 8.6942 11.1537 10.0136 11.1744C11.3323 11.195 12.7948 11.0194 14.0298 10.5725C15.9923 9.87563 17.0573 8.73813 17.1967 7.53375C18.1492 7.195 18.8529 6.87313 19.1767 6.6825L19.1598 6.66813V6.66875Z",
  fill: "#5587FF"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  d: "M0.6393 6.50625C1.1043 6.52062 1.8268 6.49687 2.6443 6.45875L5.82493 6.29625C6.34621 6.26975 6.86799 6.25433 7.38993 6.25L7.66993 6.25375C7.79805 6.2575 7.90618 6.26375 7.99243 6.27312C8.85868 6.37125 9.44868 6.77313 9.78243 7.01063C9.84467 7.05581 9.91873 7.08187 9.99555 7.08562H9.99993C10.077 7.08199 10.1513 7.05592 10.2137 7.01063L10.3856 6.89125C10.7349 6.65625 11.2705 6.35625 12.0037 6.27312C12.118 6.26062 12.2724 6.25313 12.4599 6.25063L12.6056 6.25C13.0224 6.25 13.5668 6.26875 14.1706 6.29625L17.3518 6.45875C18.1693 6.49687 18.8912 6.52125 19.3562 6.50625C19.7137 6.59375 14.8449 8.88625 9.99805 8.87688C5.14993 8.8675 0.32805 6.58312 0.6393 6.50625Z",
  fill: "#5587FF"
}, null, -1);
const _hoisted_4 = /* @__PURE__ */ createElementVNode("path", {
  d: "M10.0131 12.0069C7.70064 12.03 4.30252 10.6569 2.81002 9.135C1.51439 7.81375 1.35627 7.57125 1.13564 7.2375C1.02064 7.06437 0.908767 6.88563 0.746892 6.96688C0.651892 7.01438 1.50314 9.16938 3.35689 11.8513C5.67877 15.21 8.93314 15.625 10.075 15.625C11.2169 15.625 14.375 15.21 16.6775 11.8513C18.54 9.13563 19.2881 6.96688 19.2881 6.96688C19.264 6.95094 19.2358 6.94207 19.2069 6.94125C19.0894 6.94125 18.9925 7.09625 18.8988 7.2375C18.6794 7.57125 18.5206 7.81375 17.225 9.135C15.7325 10.6575 12.3275 12.03 10.0138 12.0069H10.0131Z",
  fill: "#5587FF"
}, null, -1);
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_5);
}
var dashboardAesthetics = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { dashboardAesthetics as default };
